export default {
    title: "Maison",
    button: {
        accessories: "Parcourir le catalogue"
    },
    noAvailableItems: "Le portail périphérique n'a pas d'articles disponibles pour votre pays pour le moment. Veuillez travailler avec votre responsable pour vous procurer les articles dont vous avez besoin.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Contactez le support</a>",
    error: "Un problème est survenu lors de la récupération des produits. S'il vous plaît rafraîchir votre navigateur."
}